export default __webpack_public_path__ + "static/media/asset-rune.84d6fe9e.svg";